import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const transcriptionSlice = createSlice({
    name: 'transcription',
    initialState: {
        isTranscribing: false,
        meetmsgID: null,
        meetButtonClicked: false,
        stopKey: null,
        shouldStopTranscription: false,
        forceStop: false // Add new state for force stop
    },
    reducers: {
        setTranscriptionState: (state, action) => {
            state.isTranscribing = action.payload;
        },
        setMeetMessageId: (state, action) => {
            state.meetmsgID = action.payload;
        },
        setMeetButtonClicked: (state, action) => {
            state.meetButtonClicked = action.payload;
        },
        setStopKey: (state, action) => {
            state.stopKey = action.payload; // Reducer to update the stopKey
        },
        setStopTranscription: (state, action) => {
            state.shouldStopTranscription = action.payload;
        },
        setForceStop: (state, action) => {
            state.forceStop = action.payload;
        }
    }
});

const persistConfig = {
    key: 'transcription',
    storage,
    whitelist: ['isTranscribing', 'meetmsgID', 'stopKey', 'forceStop'], // Add isTranscribing to whitelist
};

export const {
    setTranscriptionState,
    setMeetMessageId,
    setMeetButtonClicked,
    setStopKey,
    setStopTranscription,
    setForceStop // Export new action
} = transcriptionSlice.actions;
export default persistReducer(persistConfig, transcriptionSlice.reducer);
